var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"home-action-button",attrs:{"to":_vm.targetRoute}},[_c('span',{staticClass:"home-action-button__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }